module.exports = __webpack_public_path__ + "img/mail.fbcc73a6.png";